import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const FILE_BASE = BACKEND_URL;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("ss_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function resolveFileUrl(u) {
  if (!u) return null;
  if (u.startsWith("http")) return u;
  return `${FILE_BASE}${u}`;
}
